import { render, staticRenderFns } from "./AppointmentService.vue?vue&type=template&id=a5ea9e94&scoped=true"
import script from "./AppointmentService.vue?vue&type=script&lang=js"
export * from "./AppointmentService.vue?vue&type=script&lang=js"
import style0 from "./AppointmentService.vue?vue&type=style&index=0&id=a5ea9e94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5ea9e94",
  null
  
)

export default component.exports